export default "__VITE_ASSET__BKy$4saf__"